window.autoComplete = () => {
  return {
    expand: false,
    cursorIndex: -1,
    activeResult: null,
    inputValue: '',
    active: true,
    loading: false,
    results: [],
    noResults: false,
    query: '',
    setScrollPadding: () => {
      document.getElementsByTagName('html')[0].classList.add('scroll-pt-20');
    },
    removeScrollPadding: () => {
      document.getElementsByTagName('html')[0].classList.remove('scroll-pt-20');
    },
    getRefs(which) {
      return this.$refs[which];
    },
    async get() {
      if (!this.query || this.query == '') {
        this.results = [];
        return;
      }

      this.noResults = false;
      this.loading = true;

      let response = await fetch(restObject.root + 'wp/v2/autocomplete?' + new URLSearchParams({
        query: this.query,
      }));

      let data = await response.json();
      this.loading = false;

      if (data.length) {
        this.results = data;
      }
      else {
        this.results = [];
        this.noResults = true;
      }
    },
    up() {
      // Move up the list if there is a list and we're not at the top already.
      if (this.results.length > 0 && this.cursorIndex > 0) {
        // Decrement cursorIndex.
        this.cursorIndex--;

        // Remove active status from any other result.
        let oldActive = this.results.find(
          (result) => result.active
        );
        if (oldActive) {
          oldActive.active = false;
        }

        // Add active status to result at cursorIndex.
        this.results[this.cursorIndex].active = true;
        this.inputValue = this.results[this.cursorIndex].title;
      }
    },
    down() {
      // Move down the list only if there is room on the list to move down.
      if (this.results.length > 0 && this.cursorIndex < this.results.length - 1) {
        // Just increment the cursorIndex.
        this.cursorIndex++;

        // Remove active status from any other result.
        let oldActive = this.results.find(
          (result) => result.active
        );
        if (oldActive) {
          oldActive.active = false;
        }

        this.results[this.cursorIndex].active = true;
        this.inputValue = this.results[this.cursorIndex].title;
      }
    },
    openResult() {
      if(this.cursorIndex) {
        document.getElementById('ac-'+this.cursorIndex).click();
      }
    },
    reset() {
      this.expand = false;
      this.noResults = false;
      this.query = '';
      this.results = [];
      this.$refs.input.blur();
    },
    blur() {
      setTimeout(() => {
        this.reset();
      }, 250);
    }
  };
};
